import React from 'react'
import { useFormikContext } from 'formik'
import { EmployeeFormData } from '../../../services/api/employees'
import { Input } from 'antd'
import { transliterate } from '../../../utils/transliterate'
import { pascalize } from 'humps'
import { InputProps } from 'formik-antd'

type Props = InputProps & {
  name: string
  translitTarget?: string
}

export const NameInput: React.FunctionComponent<Props> = (props) => {
  const { name, translitTarget, ...properties } = props
  const { setFieldValue, values } = useFormikContext<EmployeeFormData>()
  const value = values[name as keyof typeof values] as string

  const handleChange = (event: any): void => {
    const value = event.target.value.trim() as string
    setFieldValue(name, pascalize(value))
    if (translitTarget) {
      setFieldValue(translitTarget, transliterate(value.toUpperCase()))
    }
  }

  return (
    <Input {...properties} value={value} name={name} onChange={handleChange} />
  )
}
